module.exports = __webpack_public_path__ + "img/file.0bbd5bc7.png";